import React, { Suspense, lazy, useEffect, useState } from "react";
import Menu from "../../Components/General/Menu/Menu";
import { FaChildren } from "react-icons/fa6";
import { MdLocalMovies } from "react-icons/md";
import { MdSports } from "react-icons/md";
import { HiOutlinePuzzle } from "react-icons/hi";
import tajikChannel from "../../Assets/Vacancies/img/tajik_icon.svg";
import "../../styles/page-sheet.scss";
import HomeGeneralSlider from "../../Components/Home/HomeGeneralSlider/HomeGeneralSlider";
import Tarifs from "../../Components/Home/Tarifs/Tarifs";
import HomeIptv from "../../Components/Home/HomeIptv/HomeIptv";
import HomeRouters from "../../Components/Home/HomeRouters/HomeRouters";
import HomeServices from "../../Components/Home/HomeServices/HomeServices";
import HomeAdvantages from "../../Components/Home/HomeAdvantages/HomeAdvantages";
import HomeApplication from "../../Components/Home/HomeApplication/HomeApplication";
import HomeNews from "../../Components/Home/HomeNews/HomeNews";
import Footer from "../../Components/General/Footer/Footer";
import img from "../../Assets/Home/img/111_Монтажная область 1 back.png";
import img2 from "../../Assets/Home/img/111_Монтажная область 1 копия.png";
import img3 from "../../Assets/Home/img/111-06.png";
import img4 from "../../Assets/Home/img//111-02.png";
import img5 from "../../Assets/Home/img/111-08.png";
import img6 from "../../Assets/Home/img/111-03.png";

import imgInfo1 from "../../Assets/Home/img/Tarifs/Frame 4.png";
import imgInfo2 from "../../Assets/Home/img/Tarifs/mts-universal-card-features → List → Item → icon_card_min.svg.png";
import imgInfo3 from "../../Assets/Home/img/Tarifs/mts-universal-card-features → List → Item → icon_card_tv.svg.png";
import imgInfo4 from "../../Assets/Home/img/Tarifs/Frame 3.png";
import imgInfo5 from "../../Assets/Home/img/Tarifs/Frame 7.png";
import imgInfo6 from "../../Assets/Home/img/Tarifs/mdi_gift-outline.png";
import imgInfo7 from "../../Assets/Home/img/Tarifs/tv.png";
import imgInfo8 from "../../Assets/Home/img/Tarifs/instagramm.png";
import backImg from "../../Assets/Home/img/image16.png";

import logo1 from "../../Assets/Home/img/Tarifs/mts-universal-card-benefits (2).png";
import logo2 from "../../Assets/Home/img/Tarifs/mts-universal-card-benefits (1).png";
import logo3 from "../../Assets/Home/img/Tarifs/mts-universal-card-benefits.png";


import homeservicesImg from "../../Assets/Home/img/HomeServices/icon-park-outline_tv.png";

import homeAdvantagesImg1 from "../../Assets/Home/img/HomeAdvantages/fluent-emoji-high-contrast_money-bag.png";
import homeAdvantagesImg2 from "../../Assets/Home/img/HomeAdvantages/ph_infinity.png";
import homeAdvantagesImg3 from "../../Assets/Home/img/HomeAdvantages/bx_support.png";

import { MdConnectedTv } from "react-icons/md";
// инет и тв

import { PiSecurityCamera, PiShieldCheck } from "react-icons/pi";
// безопасный дом


import {
  homeSlider,
  homeTerif,
  homeTerifYear,
  homeTerifYearPromo,
  homeTerifAction,
} from "./HomeLogic/HomeLogic";
import { newsData } from "../NewsModule/NewsLogic/NewsLogic";
//безопасный инет

import tarifAdditionallyImg1 from "../../Assets/Home/img/Tarifs/image (11).png";
import tarifAdditionallyImg2 from "../../Assets/Home/img/Tarifs/image (12).png";

import tarifIptvImg from "../../Assets/Home/img/Tarifs/mts-image → Picture → mts_novogodnij_848_200.avif (3).png";
import HomeConnect from "../../Components/Home/HomeConnect/HomeConnect";


// Виджет ЧМ-2026 — lazy, чтобы его код (и hls.js-плеер) не попадал
// в основной чанк главной страницы.
import WidgetErrorBoundary from "../../Components/WorldCupWidget/WidgetErrorBoundary";
import { readCache, writeCache } from "../GeneralModule/swrCache";

const WorldCupWidget = lazy(() =>
  import("../../Components/WorldCupWidget/WorldCupWidget")
);

// Ключи кэша ответов API (stale-while-revalidate, сутки)
const TARIFS_CACHE_KEY = "nets_tarifs_cache";
const NEWS_CACHE_KEY = "nets_news_cache";

const HomeModule = () => {
  // годовые пакеты преведи друга ночной безлимит
  // const [slides, setSlider] = useState([]);
  const [activeTitle, setActiveTitle] = useState(0);
  // Тарифы и новости отдаём из кэша сразу, запрос идёт параллельно и
  // заменяет данные. Пока кэша нет — показываем скелетон, см. Tarifs.
  const [tarifCards, setTarifCards] = useState(
    () => readCache(TARIFS_CACHE_KEY) ?? []
  );
  const [tarifsLoaded, setTarifsLoaded] = useState(
    () => readCache(TARIFS_CACHE_KEY) !== null
  );
  // const slides = [
  //     {
  //       image: img,
  //       image_item: img2,
  //       title: "Годовые пакеты",
  //       description:
  //         "Приобретай годовые пакеты по выгодной цене!",
  //       text_btn: "Подробнее",
  //     },
  //     {
  //       image: img6,
  //       image_item: img5,
  //       title: "Приведи друга",
  //       description: "Объединяйся с друзьями и получайте выгоду! Заполни анкету на подключение - и получи 50% кэшбека. Больше друзей, больше денег в твоем личном кабинете!",
  //       text_btn: "Подробнее",
  //     },
  //     {
  //       image: img4,
  //       image_item: img3,
  //       title: "Ночной безлимит",
  //       description: "Ночной безлимит всего за 25 сомони с 23.00 до 06.00",
  //       text_btn: "Подробнее",
  //     },
  //     // {
  //     //   image: img,
  //     //   title: "Домашний интернет 3",
  //     //   description: "С умными системами мониторинга 3",
  //     //   textBtn: "Подробнее",
  //     // },
  //   ];
  const tarifsTitle = [
    { name: "Домашний интернет" },
    { name: "Годовые пакеты" },
    { name: "IP TV" },
    { name: "Дополнительно" },
    // isNew — индикатор-точка на пилле категории (Tarifs.jsx)
    { name: "Акции", isNew: true },
  ];
  // img, title, subTitle, data, price
  const tarifIptvData = [
    {
      id: 1,
      img: tarifIptvImg,
      title: "Базовый",
      subTitle: "Пакет ТВ каналов в HD качестве",
      data: "Более 150 ТВ каналов",
      price: "20  TJS в мес",
    },
    // {id: 2, img: tarifIptvImg, title: 'Годовой', subTitle: 'Пакет ТВ каналов в HD качестве ', data: '150 ТВ каналов', price: '225  TJS в год'},
  ];
  const tarifAdditionallyData = [
    {
      id: 1,
      img: tarifAdditionallyImg1,
      title: "Ночной безлимит",
      subTitle: "с 1 ночи до 6 утра",
      dataText:
        "Снимает все ограничения по скорости интернета в ночное время, предоставляя неограниченный доступ к сети для скачивания, стриминга и других задач.",
      price: "100 TJS в месяц",
      longText: "",
    },
    // {id: 2, img: tarifAdditionallyImg1, title: 'Ночной безлимит на месяц', subTitle: 'Про ночной безлимит', data: 'Скорость до 234 MBit', price: '254  TJS в мес'},
    {
      id: 3,
      img: tarifAdditionallyImg2,
      title: "Flash",
      subTitle: "усиливай скорость на 24/ч",
      dataText:
        "Позволяет временно увеличить скорость интернета до 50 Мбит/секунд на 24 часа, обеспечивая быстрый доступ к сети в любой момент.",
      price: "25 TJS в день",
    },
    // {id: 4, img: tarifAdditionallyImg2, title: 'Flash на месяц', subTitle: 'Про Flash', data: 'Скорость до 234 MB', price: '254  TJS в мес'},
  ];


  /*
    Годовые тарифы с бэка — два запроса вместо одного. По period=year бэк
    отдаёт только те, у кого не стоит акция, поэтому «Тамошо Pro (12+2
    мес)» и Pro Max в эту выборку не попадали и были видны только во
    вкладке «Акции», хотя они и годовые тоже. Второй запрос добирает
    именно их.

    allSettled, а не all: если один из двух не ответит, вкладка покажет
    то, что пришло, вместо пустоты. Сборка по id — на случай, если на
    бэке когда-нибудь уберут это разделение и акционные начнут приходить
    первым запросом: дубля тогда не будет.
  */
  const [tarifYearCards, setTarifYearCards] = useState([]);
  useEffect(() => {
    Promise.allSettled([homeTerifYear(), homeTerifYearPromo()]).then((res) => {
      const seen = new Set();
      const rows = [];
      res.forEach((r) => {
        if (r.status !== "fulfilled") return;
        (r.value?.data ?? []).forEach((t) => {
          const key = t?.id ?? t?.name;
          if (seen.has(key)) return;
          seen.add(key);
          rows.push(t);
        });
      });
      if (rows.length) setTarifYearCards(rows);
    });
  }, []);


  // Акционные тарифы с бэка (GET tarifs/?is_promo=true). Хардкодный фоллбек
  // убран: выборка отдаёт 2 тарифа.
  const [tarifActionCards, setTarifActionCards] = useState([]);
  useEffect(() => {
    homeTerifAction()
      .then((res) => {
        if (res.data?.length) setTarifActionCards(res.data);
      })
      .catch(() => {});
  }, []);

  const homeServicesData = [
    {
      id: 1,
      title: "Родительский Контроль",
      subTitle: [
        {
          item: "Возможность контролировать доступ в интернет на каждом устройстве.",
        },
        {
          item: "Мониторинг активности в сети и повышение уровня безопасности.",
        },
      ],
      textBtn: "Подробнее",
      img: <PiShieldCheck className="img" />,
    },
    {
      id: 2,
      title: "Видеонаблюдение от NETS",
      subTitle: [
        {
          item: "Камеры можно смотреть в приложении отовсюду, где есть интернет;",
        },
        { item: "Записи в безопасности на облачном сервере;" },
        { item: "Бесплатная установка при покупке камеры для абонентов NETS" },
      ],
      textBtn: "Подробнее",
      img: <PiSecurityCamera className="img" />,
    },
    {
      id: 3,
      title: "Интернет + ТВ",
      subTitle: [
        { id: 1, item: "Подключаем в удобное для вас время;" },
        { id: 2, item: "При подключении даём IPTV в аренду или рассрочку;" },
        {
          id: 3,
          item: "Более 240 телеканалов, более 50 из которых в HD-качестве;",
        },
        { id: 4, item: "IPTV  25 сомони в месяц." },
      ],
      textBtn: "Подробнее",
      img: <MdConnectedTv className="img" />,
    },
  ];
  const homeAdvantagesCardData = [
    {
      id: 1,
      img: homeAdvantagesImg1,
      title: "Широкий выбор тарифов",
      subTitle:
        "Мы предлагаем разнообразные тарифные планы, соответствующие потребностям различных категорий пользователей, от индивидуальных абонентов до крупных корпоративных клиентов.",
    },
    {
      id: 2,
      img: homeAdvantagesImg2,
      title: "Безлимитный интернет",
      subTitle:
        "Наслаждайтесь свободой использования интернета без ограничений по трафику или скорости. Наша услуга предоставляет вам полный доступ к контенту в сети без дополнительных платежей.",
    },
    {
      id: 3,
      img: homeAdvantagesImg3,
      title: "Качественное обслуживание клиентов",
      subTitle:
        "Наша команда профессионалов всегда готова ответить на ваши вопросы и решить любые технические проблемы. Мы ценим каждого клиента и стремимся обеспечить их высоким сервисом.",
    },
  ];
  const menuLink = [
    { id: 1, name: "Тарифы", link: "#tarifs" },
    { id: 2, name: "Акции", link: "#tarifs-actions" },
    { id: 3, name: "Услуги", link: "#services" },
    { id: 4, name: "Новости", link: "#news" },
    { id: 5, name: "VPS", link: "/hosting", vps: true },
  ];
  const IptvCannel = [
    {
      id: 1,
      title: "Таджикские",
      subTitle: "Документальные фильмы, сериалы и новости.",
      icon: <img src={tajikChannel} alt="" className="homeIptvListitem_img" />,
    },
    {
      id: 2,
      title: "Спортивные",
      subTitle:
        "Прямые эфиры спортивных событий, обзоры матчей и аналитические передачи.",
      icon: <MdSports className="homeIptvListitem_img" />,
    },
    {
      id: 3,
      title: "Кино",
      subTitle: "Отечественные и зарубежные фильмы разных жанров",
      icon: <MdLocalMovies className="homeIptvListitem_img" />,
    },
    {
      id: 4,
      title: "Детские",
      subTitle: "Программы для детей всех возрастов",
      icon: <FaChildren className="homeIptvListitem_img" />,
    },
    {
      id: 5,
      title: "Развлекательные",
      subTitle: "Контент для отдыха и досуга",
      icon: <HiOutlinePuzzle className="homeIptvListitem_img" />,
    },
  ];
  const homeConnect = [
    {
      id: 1,
      title: "Оставьте заявку",
      subTitle:
        "Свяжемся с вами в ближайшее время, проверим возможность подключения и договоримся об удобном времени установки оборудования",
      active: true,
    },
    {
      id: 2,
      title: "Ожидайте специалиста",
      subTitle:
        "В назначенное время приедет специалист, привезёт договор, подключит и настроит домашний интернет Nets",
    },
    {
      id: 3,
      title: "Выберите где расположить роутер",
      subTitle:
        "Можно подключить прозрачную оптику или любой подходящий провод",
    },
    {
      id: 4,
      title: "Начните пользоваться интернетом Nets",
      subTitle:
        "После установки вы получите данные для входа в Личный кабинет. Оплатите интернет, чтобы сразу начать им пользоваться. Также вы можете подключить дополнительные услуги от Nets",
    },
  ];
  const getHomeTarif = () => {
    homeTerif()
      .then((res) => {
        setTarifCards(res.data);
        setTarifsLoaded(true);
        writeCache(TARIFS_CACHE_KEY, res.data);
      })
      .catch((err) => {
        setTarifsLoaded(true);
        console.log(err);
      });
  };
  const [news, setNews] = useState(() => readCache(NEWS_CACHE_KEY) ?? undefined);

  const getNewsData = () => {
    newsData()
      .then((res) => {
        setNews(res.data);
        writeCache(NEWS_CACHE_KEY, res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const activeTitleIptv = () => {
    setActiveTitle(2);
  };

  useEffect(() => {
    getHomeTarif();
    getNewsData();
  }, []);
  return (
    <div>
      <Menu menuLink={menuLink} />
      {/* Виджет ЧМ-2026 временно скрыт с главной (акция не активна).
          Компонент/чанк/роут правил оставлены — вернуть = раскомментировать.
      <WidgetErrorBoundary>
        <Suspense fallback={<div style={{ minHeight: 64 }} aria-hidden="true" />}>
          <WorldCupWidget />
        </Suspense>
      </WidgetErrorBoundary>
      */}
      {/*
        Герой и лист — в одном стекинг-контексте (isolation: isolate):
        их z-index (0 и 2) больше не зависят от остального дерева
        страницы. Лист — всё после героя до конца документа, футер
        включительно; плашка cookie fixed и в лист не входит.
      */}
      <div className="home-stack">
      <HomeGeneralSlider hero />
      <div className="page-sheet">
      <Tarifs
        tarifsLoaded={tarifsLoaded}
        tarifsTitle={tarifsTitle}
        tarifCards={tarifCards}
        tarifIptvData={tarifIptvData}
        tarifAdditionallyData={tarifAdditionallyData}
        tarifYearCards={tarifYearCards}
        tarifActionCards={tarifActionCards}
        activeTitle={activeTitle}
        setActiveTitle={setActiveTitle}
      />
      <HomeConnect data={homeConnect} />
      <HomeRouters />
      <HomeIptv IptvCannel={IptvCannel} activeTitleIptv={activeTitleIptv} />
      <HomeServices homeServicesData={homeServicesData} />
      <HomeAdvantages
        homeAdvantagesCardData={homeAdvantagesCardData}
        title={"Преимущества"}
      />
      <HomeApplication />
      <HomeNews newsData={news} />
      <Footer />
      </div>
      </div>
    </div>
  );
};

export default HomeModule;
